export default "__VITE_ASSET__CyJtSfb7__"